module.exports = __webpack_public_path__ + "img/Fiat.d0794259.png";